export const environment = {
  production: false,
  language: 'en',
  site_key: '6LdFEe0dAAAAAN-baA5__-7z1vHRhxgynNhHrPnC',
  backendUrl: 'https://backend.affiliate.webiz.com',
  trackerUrl: 'https://tracker.affiliate.webiz.com',
};